import React, { useState } from 'react'
import { useStaticQuery, graphql } from "gatsby"

import './save-modal.scss'
import Button from '../../atoms/button/button'

const SaveModal = props => {

    const resultQuery = useStaticQuery(
        graphql`
            query MODAL_QUERY{
                allContentfulNolHomeTercerNivel(filter: {slug: {eq: "cuidado-femenino"}}) {
                    nodes {
                      node_locale
                      modalGuardadoBotonInicioSesion
                      modalGuardadoBotonRegistro
                      modalGuardadoDescripcion
                      modalGuardadoTitulo
                      slug
                    }
                  }
            }
        `
    )
    const [modalState, setModalState] = useState(false)
    const [classHide, setClassHide] = useState('')

    setTimeout(() => {//Set animation inside
        setModalState(true)
    }, 200);

    const hideSaveModal = () => {
        setClassHide('hidden-modal');
        setTimeout(() => {//Set animation outside
            props.closeModal();
        }, 1000);

    }

    const filteredResultQuery = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]

    return (
        <div className={"f-curtain-modal " + (modalState && ' active-modal ') + classHide}>
            <div className="f-modal-container">
                <span
                    onClick={() => hideSaveModal()}
                    className="icon2-close f-icon f-icon-close-modal"
                />
                <div className="f-modal-title-container">
                    <label className="f-modal-title">
                        {filteredResultQuery.modalGuardadoTitulo}
                    </label>
                </div>
                <div className="f-modal-description-container">
                    <p className="f-modal-description">
                        {filteredResultQuery.modalGuardadoDescripcion}
                    </p>
                </div>
                <div className="f-modal-buttons-container">
                    <a href="/login">
                        <Button
                            className="primary-pink short modal-save-button f-btn-login"
                            title={filteredResultQuery.modalGuardadoBotonInicioSesion}
                        />
                    </a>
                    <a href="/registro">
                        <Button
                            className="secondary-blue short secondary-modal modal-save-button"
                            title={filteredResultQuery.modalGuardadoBotonRegistro}
                        />

                    </a>
                </div>
            </div>
        </div>
    )
}

export default SaveModal
